<template>
  <div class="review">
    <div class="review__btn-wrapper">
      <button @click="$emit('closeReviewQuestions')" class="review__back-btn">
        <LeftCaretIcon class="review__back-icon" />
        Back
      </button>
    </div>
    <div class="review__questions-wrapper">
      <h3 class="review__title">Questions You Missed:</h3>
      <div
        v-for="(question, i) in missedQuestions"
        :key="`review-question-${i}`"
        class="review__question"
      >
        <IncorrectQuestionIcon class="review__incorrect-icon" />
        <div class="review__question-text">{{ question._content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftCaretIcon from '@/assets/icons/navigation/left_caret.svg'
import IncorrectQuestionIcon from '@/assets/icons/course/quiz/incorrect_question.svg'

export default {
  name: 'ReviewQuestions',
  components: {
    LeftCaretIcon: { ...LeftCaretIcon, name: 'LeftCaretIcon' },
    IncorrectQuestionIcon: {
      ...IncorrectQuestionIcon,
      name: 'IncorrectQuestionIcon',
    },
  },
  props: {
    missedQuestions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.review {
  display: flex;
  flex-direction: column;
  @include desktop {
    flex-direction: row;
    margin: 30px 0 0 0;
    padding: 0 0 100px 0;
  }
  &__back-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 22px;
    background: transparent;
    padding: 10px 25px;
    margin: 0 75px 0 -50px;
    border: 3px solid var(--border-gray);
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    max-height: 55px;
    cursor: pointer;
    &:hover {
      background: var(--border-gray);
    }
  }
  &__back-icon {
    margin: 0 20px 0 0;
  }
  &__title {
    margin: 0 0 75px 0;
    padding: 0;
    font-size: 32px;
    font-weight: 500;
  }
  &__questions-wrapper {
    max-width: 1800px;
  }
  &__question {
    display: flex;
    font-size: 18px;
    flex-wrap: wrap;
    @include mobile {
      flex-wrap: nowrap;
    }
  }
  &__incorrect-icon {
    margin: 0 10px 0 0;
  }
  &__question-text {
    width: 100%;
    padding: 0 0 20px 0;
    margin: 0 0 20px 0;
    border-bottom: 3px solid var(--border-gray);
  }
}
</style>
